import {
  GET_COMPANIES,
  GET_COMPANIES_SUCCEED,
  GET_COMPANIES_FAILED,
  GET_COMPANY_DETAILS,
  GET_COMPANY_DETAILS_SUCCEED,
  GET_COMPANY_DETAILS_FAILED,
  REMOVE_COMPANY_INFO,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCEED,
  GET_COUNTRIES_FAILED,
  CRM_UPDATE_SELECTED_COMPANY,
  CRM_UPDATE_SELECTED_COMPANY_SUCCEED,
  CRM_UPDATE_SELECTED_COMPANY_FAILED,
  CREATE_PAYMENT_INFO,
  CREATE_PAYMENT_INFO_SUCCEED,
  CREATE_PAYMENT_INFO_FAILED,
  GET_CRM_CATEGORIES,
  GET_CRM_CATEGORIES_SUCCEED,
  GET_CRM_CATEGORIES_FAILED,
  GET_CRM_COUNTRY_DATASET,
  GET_CRM_COUNTRY_DATASET_SUCCEED,
  GET_CRM_COUNTRY_DATASET_FAILED,
  CREATE_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_SUCCEED,
  CREATE_SUBSCRIPTION_FAILED,
  CRM_INVITE_USER,
  CRM_INVITE_USER_SUCCEED,
  CRM_INVITE_USER_FAILED,
  CRM_REMOVE_USER,
  CRM_GET_STAFF,
  CRM_GET_STAFF_SUCCEED,
  CRM_GET_STAFF_FAILED,
  CRM_REMOVE_COMPANY,
  CRM_REMOVE_COMPANY_SUCCEED,
  CRM_REMOVE_COMPANY_FAILED,
  GET_AUDIENCE_ACTIVITY,
  GET_AUDIENCE_ACTIVITY_SUCCEED,
  GET_AUDIENCE_ACTIVITY_FAILED,
  RESET_ERRORS_AUDIENCE_ACTIVITY
} from "../constants";

const initialState = {
  companies: [],
  companiesLoading: false,
  selectedCompany: null,
  errors: null,
  countries: [],
  isInvitingUser: false,
  countriesLoading: false,
  categories: [],
  audienceActivity: {
    isDownloaded: false,
    errors: null,
    isActivityLoading: false,
    data: null,
    fileName: null
  },
  categoriesLoading: false,
  countryDatasets: [],
  datasetsLoading: false,
  staff: [],
  isStaffLoading: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_COMPANIES:
      return {
        ...state,
        companiesLoading: true,
        errors: null
      };
    case GET_COMPANIES_SUCCEED:
      return {
        ...state,
        companies: [...payload],
        companiesLoading: false
      };
    case GET_COMPANIES_FAILED:
      return {
        ...state,
        companies: [],
        companiesLoading: false,
        errors: payload
      };
    case GET_COMPANY_DETAILS:
      return {
        ...state,
        isCompanyLoading: true
      };
    case GET_COMPANY_DETAILS_SUCCEED:
      return {
        ...state,
        selectedCompany: payload,
        isCompanyLoading: false
      };
    case GET_COMPANY_DETAILS_FAILED:
      return {
        ...state,
        selectedCompany: null,
        isCompanyLoading: false,
        errors: payload
      };
    case GET_AUDIENCE_ACTIVITY:
      return {
        ...state,
        audienceActivity: {
          isActivityLoading: true
        }
      };
    case GET_AUDIENCE_ACTIVITY_SUCCEED:
      return {
        ...state,
        audienceActivity: {
          ...payload
        }
      };
    case GET_AUDIENCE_ACTIVITY_FAILED:
      return {
        ...state,
        audienceActivity: {
          data: null,
          isDownloaded: false,
          errors: payload?.error,
          isActivityLoading: false,
          fileName: null
        }
      };
    case RESET_ERRORS_AUDIENCE_ACTIVITY:
      return {
        ...state,
        audienceActivity: {
          errors: null
        }
      };
    case REMOVE_COMPANY_INFO:
      return {
        ...state,
        selectedCompany: null
      };
    case GET_COUNTRIES:
      return {
        ...state,
        countriesLoading: true
      };
    case GET_COUNTRIES_SUCCEED:
      return {
        ...state,
        countries: payload,
        countriesLoading: false
      };
    case GET_COUNTRIES_FAILED:
      return {
        ...state,
        countries: [],
        countriesLoading: false,
        errors: payload
      };
    case CRM_UPDATE_SELECTED_COMPANY:
      return {
        ...state,
        companiesLoading: true
      };
    case CRM_UPDATE_SELECTED_COMPANY_SUCCEED:
      return {
        ...state,
        companiesLoading: false,
        selectedCompany: payload,
        errors: null
      };
    case CRM_UPDATE_SELECTED_COMPANY_FAILED:
      return {
        ...state,
        companiesLoading: false,
        errors: payload
      };
    case CREATE_PAYMENT_INFO:
      return {
        ...state
      };
    case CREATE_PAYMENT_INFO_SUCCEED:
      return {
        ...state,
        selectedCompany: {
          ...state.selectedCompany,
          paymentInfo: payload
        }
      };
    case CREATE_PAYMENT_INFO_FAILED:
      return {
        ...state,
        errors: payload
      };
    case CREATE_SUBSCRIPTION:
      return {
        ...state,
        subscriptionCreating: true
      };
    case CREATE_SUBSCRIPTION_SUCCEED:
      return {
        ...state,
        subscriptionCreating: false,
        selectedCompany: {
          ...state.selectedCompany,
          subscription: payload
        }
      };
    case CREATE_SUBSCRIPTION_FAILED:
      return {
        ...state,
        subscriptionCreating: false,
        errors: payload
      };
    case GET_CRM_CATEGORIES:
      return {
        ...state,
        categoriesLoading: true
      };
    case GET_CRM_CATEGORIES_SUCCEED:
      return {
        ...state,
        categoriesLoading: false,
        categories: payload
      };
    case GET_CRM_CATEGORIES_FAILED:
      return {
        ...state,
        categoriesLoading: false,
        errors: payload
      };
    case GET_CRM_COUNTRY_DATASET:
      return {
        ...state,
        datasetsLoading: true
      };
    case GET_CRM_COUNTRY_DATASET_SUCCEED:
      return {
        ...state,
        datasetsLoading: false,
        countryDatasets: payload
      };
    case GET_CRM_COUNTRY_DATASET_FAILED:
      return {
        ...state,
        datasetsLoading: false,
        errors: payload
      };

    case CRM_GET_STAFF:
      return {
        ...state,
        isStaffLoading: true
      };
    case CRM_GET_STAFF_SUCCEED:
      return {
        ...state,
        staff: payload,
        isStaffLoading: false
      };
    case CRM_GET_STAFF_FAILED:
      return {
        ...state,
        errors: payload,
        isStaffLoading: false
      };

    case CRM_INVITE_USER:
      return {
        ...state,
        isInvitingUser: true
      };
    case CRM_INVITE_USER_SUCCEED:
      return {
        ...state,
        selectedCompany: {
          ...state.selectedCompany,
          members: [...state.selectedCompany.members, payload]
        },
        isInvitingUser: false,
        errors: null
      };
    case CRM_INVITE_USER_FAILED:
      return {
        ...state,
        errors: payload,
        isInvitingUser: false
      };
    case CRM_REMOVE_USER:
      return {
        ...state,
        selectedCompany: {
          ...state.selectedCompany,
          members: state.selectedCompany.members.filter(
            ({ id }) => id !== payload
          )
        }
      };
    case CRM_REMOVE_COMPANY:
      return {
        ...state,
        isLoading: true
      };
    case CRM_REMOVE_COMPANY_SUCCEED:
      return {
        ...state,
        isLoading: false,
        companies: [
          ...state.companies.filter(company => company.id !== payload)
        ]
      };
    case CRM_REMOVE_COMPANY_FAILED:
      return {
        ...state,
        isLoading: false,
        errors: payload
      };
    default:
      return state;
  }
};
